import { useTranslation } from "react-i18next";
import { Link as RouterLink, useLocation } from "react-router-dom";
import { Button } from "@carbon/react";
import { CheckmarkFilled } from "@carbon/icons-react";
import { SignUpResponse } from "../types";
import "./success.scss";

/** The post-signup confirmation (Carbon). Reads the real Task-3 signup DTO fields
 * (`fullName`) defensively — optional chaining, so a missing field just omits the
 * name rather than crashing. */
export default function Success({
  signUpResponse,
}: {
  signUpResponse: SignUpResponse;
}) {
  const { t } = useTranslation();
  const isRedirect = new URLSearchParams(useLocation().search).get(
    "redirectURL"
  );
  return (
    <div className="register-success">
      <CheckmarkFilled
        size={48}
        className="register-success__icon"
        aria-hidden="true"
      />
      <p className="register-success__greeting">
        {t("register.form.hi")} {signUpResponse?.data?.fullName}!{" "}
        {t("register.form.welcome")}
      </p>
      <p className="register-success__apply">
        <strong>{t("register.form.apply")}</strong>
      </p>
      <Button
        as={RouterLink}
        to={isRedirect ? `/?redirectURL=${isRedirect}` : "/"}
        className="register-success__login"
      >
        {t("register.form.login")}
      </Button>
    </div>
  );
}
